"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GalleryThumbnails = void 0;
var react_1 = __importStar(require("react"));
var SkeletonLoader_1 = require("../../../../../LoadersAndProgress/SkeletonLoader");
var ImageInputContext_1 = require("../../../../ImageInputContext");
var styled_1 = require("./styled");
var ImageDisplayInMask_1 = require("../../../../derivedComps/ImageDisplayInMask");
var themes_1 = require("../../../../../../themes");
var icons_1 = require("../../../../../../icons");
var useScreenWidth_1 = require("../../../../../../utils/customHooks/useScreenWidth");
var makeArrayFromLength_1 = require("../../../../../../utils/makeArrayFromLength");
var FileUploadShell_1 = require("../../../../../FileUploadWrapper/comps/FileUploadShell");
var Plus = icons_1.icons.Plus;
var GalleryThumbnails = function (_a) {
    var activeIdx = _a.activeIdx, setActiveIdx = _a.setActiveIdx;
    var _b = (0, ImageInputContext_1.useImageInputContext)(), value = _b.value, isLoading = _b.isLoading, noOfImagesUploading = _b.noOfImagesUploading, readOnly = _b.readOnly, invert = _b.invert, aspectRatio = _b.aspectRatio, handleUpload = _b.handleUpload, onChange = _b.onChange, id = _b.id;
    var _c = (0, react_1.useState)(0), placeholderThumbsToRender = _c[0], setPlaceholderThumbsToRender = _c[1];
    var totThumbsSpaceRef = (0, react_1.useRef)(null);
    var addMoreThumbnailRef = (0, react_1.useRef)(null);
    var screenWidth = (0, useScreenWidth_1.useScreenWidth)();
    (0, react_1.useEffect)(function () {
        if (!readOnly) {
            var thumbnailWidth = addMoreThumbnailRef.current.offsetWidth;
            var totAvailableSpace = totThumbsSpaceRef.current.offsetWidth - thumbnailWidth - 10;
            var gap = 10;
            var noOfThumbsWillFit = Math.floor(totAvailableSpace / (thumbnailWidth + gap));
            setPlaceholderThumbsToRender(noOfThumbsWillFit);
        }
    }, [screenWidth]);
    /**
     * create array of thumbnails to render.
     * this is made up of 2 things:
     * 1 : the value array which holds the images data
     * PLUS 2 : the noOfImagesUploading that will render skeleton loaders for images currently loading
     */
    var imageThumbnailsData = __spreadArray(__spreadArray([], ((0, makeArrayFromLength_1.makeArrayFromLength)(noOfImagesUploading).map(function (d) { return undefined; })), true), (value || []), true);
    return (react_1.default.createElement("div", { ref: totThumbsSpaceRef, style: { display: 'flex', gap: '1rem' } },
        !readOnly && (react_1.default.createElement(styled_1.StyledAddMoreThumbnail, { ref: addMoreThumbnailRef, disabled: isLoading, noBorder: true, invert: invert },
            react_1.default.createElement(FileUploadShell_1.FileUploadShell, { disabled: isLoading, multiple: true, mediaType: 'image', handleUpload: handleUpload, onChange: onChange, value: value, id: id },
                react_1.default.createElement("div", { style: {
                        display: "grid",
                        placeItems: "center",
                        cursor: "pointer",
                        height: "100%",
                    } },
                    react_1.default.createElement(Plus, { size: 24, weight: "bold", color: invert ? themes_1.colors.greyColor100 : themes_1.colors.white }))))),
        react_1.default.createElement(styled_1.StyledSliderWrapper, null,
            imageThumbnailsData.map(function (v, idx) {
                return (react_1.default.createElement(styled_1.StyledImageThumbnail, { key: (v === null || v === void 0 ? void 0 : v.publicUrl) || idx, onClick: function () { return setActiveIdx(idx); }, isActive: activeIdx === idx, invert: invert }, v
                    ? react_1.default.createElement(ImageDisplayInMask_1.ImageDisplayInMask, { maskAspectRatio: '1', id: 'thumb' + idx, invert: invert, disableImageBorder: true, defaultImageSpread: 'contain', value: [v], aspectRatio: aspectRatio })
                    : react_1.default.createElement(SkeletonLoader_1.SkeletonLoader, { style: { width: '100%', height: '100%' } })));
            }),
            (!value || value.length === 0) &&
                (0, makeArrayFromLength_1.makeArrayFromLength)(placeholderThumbsToRender).map(function (order) {
                    return (react_1.default.createElement(styled_1.StyledPlaceholderThumbnail, { key: "blank thumbnail" + order, isBlank: true }));
                }))));
};
exports.GalleryThumbnails = GalleryThumbnails;
